const chapters = [
    "บททั่วไป",
    "พระมหากษัตริย์",
    "สิทธิและเสรีภาพของปวงชนชาวไทย",
    "หน้าที่ของปวงชนชาวไทย",
    "หน้าที่ของรัฐ",
    "แนวนโยบายแห่งรัฐ",
    "รัฐสภา",
    "คณะรัฐมนตรี",
    "การขัดกันแห่งผลประโยชน์",
    "ศาล",
    "ศาลรัฐธรรมนูญ",
    "องค์กรอิสระ",
    "องค์กรอัยการ",
    "การปกครองส่วนท้องถิ่น",
    "การแก้ไขเพิ่มเติมรัฐธรรมนูญ",
    "การปฏิรูปประเทศ",
    "บทเฉพาะกาล",
]

// Used for data query
export const chapterNameToId = {
    "บททั่วไป": "1",
    "พระมหากษัตริย์": "2",
    "สิทธิและเสรีภาพของปวงชนชาวไทย": "3",
    "หน้าที่ของปวงชนชาวไทย": "4",
    "หน้าที่ของรัฐ": "5",
    "แนวนโยบายแห่งรัฐ": "6",
    "รัฐสภา": "7",
    "คณะรัฐมนตรี": "8",
    "การขัดกันแห่งผลประโยชน์": "9",
    "ศาล": "10",
    "ศาลรัฐธรรมนูญ": "11",
    "องค์กรอิสระ": "12",
    "องค์กรอัยการ": "13",
    "การปกครองส่วนท้องถิ่น": "14",
    "การแก้ไขเพิ่มเติมรัฐธรรมนูญ": "15",
    "การปฏิรูปประเทศ": "16",
    "บทเฉพาะกาล": "บทเฉพาะกาล",
}

// Used for data query
export const chapterIdToName = {
    "1": "บททั่วไป",
    "2": "พระมหากษัตริย์",
    "3": "สิทธิและเสรีภาพของปวงชนชาวไทย",
    "4": "หน้าที่ของปวงชนชาวไทย",
    "5": "หน้าที่ของรัฐ",
    "6": "แนวนโยบายแห่งรัฐ",
    "7": "รัฐสภา",
    "8": "คณะรัฐมนตรี",
    "9": "การขัดกันแห่งผลประโยชน์",
    "10": "ศาล",
    "11": "ศาลรัฐธรรมนูญ",
    "12": "องค์กรอิสระ",
    "13": "องค์กรอัยการ",
    "14": "การปกครองส่วนท้องถิ่น",
    "15": "การแก้ไขเพิ่มเติมรัฐธรรมนูญ",
    "16": "การปฏิรูปประเทศ",
    "บทเฉพาะกาล": "บทเฉพาะกาล",
}

export default chapters
